export default [
  {
    type: 'subtitle',
    content: 'CUSTOMER TERMS AND CONDITIONS',
  },
  {
    type: 'subtitle',
    content: 'TAMARA',
  },
  {
    type: 'text',
    content: 'Welcome!',
  },
  {
    type: 'text',
    content:
      'Hello, we’re <strong>Tamara</strong>. Through our Mobile App you may be able to shop with some of your favorite retailers by selecting one of our Tamara Services at checkout.',
  },

  {
    type: 'subtitle',
    content: 'How to get in touch',
  },
  {
    type: 'text',
    content:
      'If you’d like to get in touch with us about our Tamara Services, please contact us by using Tamara’s Customer Help Center. ',
  },
  {
    type: 'text',
    content:
      'If you have a Tamara Account with us don’t forget to check your emails or messages communicated to you via your Tamara Account as that is normally how we will contact you about your Tamara Account. ',
  },
  {
    type: 'text',
    content:
      'We’ve split our Customer Terms and Conditions into easy to access sections, which are as follows: ',
  },
  {
    type: 'text',
    content:
      '<strong>Section One – Introduction</strong> – this sets out the purpose of these terms and how we (as Tamara) may make amendments to the Terms and Conditions. ',
  },
  {
    type: 'text',
    content:
      '<strong>Section Two – Your use of the Tamara Services</strong> - this sets out the relevant rules and obligations in relation to your use of the Tamara Services, including with regards to payment. ',
  },
  {
    type: 'text',
    content:
      '<strong>Section Three – General Terms</strong> – this section includes a series of obligations between you as Customer and us as Tamara, including (on a non-exhaustive basis) with regards to how we deal with personal data, our liability to you in the event something goes wrong, and the law which governs these Terms and Conditions. ',
  },
  {
    type: 'text',
    content:
      '<strong>Section Four – Definitions</strong> – this section includes the definitions relating to any capitalized terms used in these Terms and Conditions. ',
  },

  {
    type: 'text',
    content:
      'We recommend reading these carefully to familiarise yourself with our Customer Terms and Conditions and understand how our Tamara Services work.',
  },

  {
    type: 'subtitle',
    content: 'SECTION ONE - INTRODUCTION',
  },
  {
    type: 'subtitle',
    content: '1. Introduction',
  },
  {
    type: 'text',
    content:
      '<strong>1.1.</strong> These Terms and Conditions constitute a legally binding agreement between you (either personally or on behalf of an entity you represent) and Tamara FZE ("<strong>Tamara</strong>"), hereinafter referred to as "<strong>We</strong>", with respect to all aspects of the Tamara Services and/or your use of the Mobile App or your access to the Website, as well as any other media form, media channel, website or mobile application related to, or linked to and through your access to and use of the Mobile App or Website. You acknowledge that you have read, understood and agreed to be bound by these Terms and Conditions, as amended from time to time. If you do not agree to these Terms and Conditions, you must stop using or accessing the Tamara Services, the Mobile App and/or Website immediately. If you are using the Mobile App or the Website on behalf of a third party including, without limitation, any business entity, you warrant that you are authorised and have the authority to commit such third party to these Terms and Conditions.',
  },
  {
    type: 'text',
    content:
      '<strong>1.2.</strong> The Merchant from whom you purchase goods or services using Tamara Services is not a party to these Terms and Conditions and any applicable terms between you and the Merchant are independent of these Terms and Conditions. ',
  },
  {
    type: 'text',
    content:
      '<strong>1.3.</strong> We reserve the right, at our absolute discretion, to make changes or modifications to these Terms and Conditions at any time for any reason, including any other terms and conditions published on the Website or the Mobile App from time to time and those referred to in clause 12 below. We shall provide you with at least thirty (30) days’ notice of any changes to these Terms and Conditions (unless otherwise permitted or required by Applicable Laws) via the agreed means of communication as further described below. ',
  },
  {
    type: 'text',
    content:
      '<strong>1.4.</strong> Your continued use of the Website and/or the Mobile App, including the applicable Tamara Service to which an amendment relates to, after the revised Terms and Conditions are communicated to you, shall constitute an acknowledgement from you that you have read and understood the amendments and accepted the changes.',
  },

  {
    type: 'subtitle',
    content: 'Section Two – Your use of the Tamara Services',
  },
  {
    type: 'subtitle',
    content: '2. Eligibility and Validity',
  },
  {
    type: 'text',
    content:
      '<strong>2.1.</strong> By using the Tamara Services you warrant and represent that you have the legal capacity to enter into these Terms and Conditions, that you are over the age of eighteen (18) years and that you will be utilising the service in your personal capacity using payment methods that are yours and which are at all times registered in your name. ',
  },
  {
    type: 'text',
    content:
      '<strong>2.2.</strong> By clicking to agree to these Terms and Conditions, you acknowledge that you have entered into these Terms and Conditions electronically.',
  },

  {
    type: 'subtitle',
    content: '3.Accounts and Registration',
  },
  {
    type: 'text',
    content:
      '<strong>3.1.</strong> The process of registering the Tamara Account requires you to provide Tamara with certain personal information for the purposes of (i) creating a Tamara Account; (ii) providing any Tamara Services to you; and (iii) complying with any Applicable Laws, including, but not limited to, any “Know Your Customer” compliance obligations. Such information may include your full name, address, email, phone number and age. You acknowledge and agree that any personal information provided is true, accurate, complete and up-to-date, and you shall promptly notify Tamara of any changes to your personally identifiable information or any other information or circumstances that may affect your eligibility to continue to use the Tamara Services or are otherwise required in accordance with these Terms and Conditions.',
  },
  {
    type: 'text',
    content:
      '<strong>3.2</strong> You hereby agree to disclose all of your financial obligations, as requested by Tamara or any of its agents or subcontractors, and to refrain from withholding any information that may be impactful or important to any of the parties involved in providing the Tamara Services to you.',
  },
  {
    type: 'text',
    content:
      '<strong>3.3.</strong> You hereby agree that you will be responsible for any activity under your Tamara Account and agree to maintain appropriate security measures for your account details on an ongoing basis. ',
  },
  {
    type: 'text',
    content:
      '<strong>3.4.</strong> If your password is lost or stolen, or if you believe that there is unauthorised access to your Tamara Account, you must change the password for your Tamara Account and notify us immediately. You are responsible for any Transactions made using your stolen Tamara Account credentials unless you promptly notify us of the suspension and receive a message from Tamara stating that your Tamara Account is suspended or terminated.',
  },
  {
    type: 'text',
    content:
      '<strong>3.5.</strong> You shall not share your Tamara Account credentials with any other person. You acknowledge and agree to refund to Tamara, if requested by us, the value of any Transaction made using your Tamara Account which was requested by you or by any other person who has accessed the Tamara Services through the use of your own username or password, whether or not you have allowed such access. You also acknowledge and agree that Tamara reserves the right to cancel any Transaction if it is discovered that you have shared your Tamara Account credentials with any other person.',
  },
  {
    type: 'text',
    content:
      '<strong>3.6.</strong> You shall immediately notify Tamara of any suspected or actual fraudulent or illegal activity identified as a result of your use of the Tamara Services (including relating to any acts or omissions of any Merchant). Failure to do so may result in suspension or termination of your Tamara Account, as well as any other additional legal action taken by Tamara at its full discretion. Where the suspected or actual fraudulent or illegal activity originates from a Merchant or Merchant Platform using Tamara Services, you shall immediately report such Merchant or Merchant Platform (as applicable) to Tamara before taking any further action.',
  },
  {
    type: 'text',
    content:
      '<strong>3.7.</strong> At its full discretion, should Tamara have any doubts that any of the information you provided is incorrect, inaccurate, incomplete or not up to date, without prejudice to any other rights or remedies, in accordance with these Terms and Conditions or pursuant to the Applicable Laws, Tamara shall have the right to stop or restrict access to the Tamara Services, the Mobile App and/or the Website. ',
  },
  {
    type: 'text',
    content:
      '<strong>3.8.</strong> Tamara may, at its full discretion, make any inquiries it deems necessary (whether directly or through a third party, including for instance, from any credit bureau agency), and request you to provide further information or documents as deemed necessary. You acknowledge and agree to provide any information and/or documents to Tamara upon request. You further acknowledge and agree that if you are unable to do so, Tamara may, without any liability, limit, suspend or withdraw your access to the Tamara Services, Mobile App or Website. Tamara reserves the right to cancel any unconfirmed or unverified accounts or accounts that have not been active for a period of time at its full discretion. ',
  },
  {
    type: 'text',
    content:
      '<strong>3.9.</strong> Upon completing the registration process, you acknowledge and agree that you have read these Terms and Conditions, understand them and agree to be bound by them. These Terms and Conditions shall be deemed to include the Tamara Privacy Policy, available on the Website and as updated from time to time. ',
  },
  {
    type: 'text',
    content:
      '<strong>3.10.</strong> Where your application for a Tamara Account or the provision of any specific Tamara Services has been rejected, we shall aim to inform you of the reason for such rejection within five (5) days or a time period otherwise permitted by Applicable Laws, whichever is longer. ',
  },
  {
    type: 'text',
    content:
      '<strong>3.11.</strong> You agree to cooperate and provide reasonable assistance to Tamara in order to enable us to comply with any of our applicable regulatory obligations or as required by any applicable regulatory authority. ',
  },

  {
    type: 'subtitle',
    content: '4. Tamara Services',
  },
  {
    type: 'text',
    content:
      '<strong>4.1.</strong> Tamara is a financing company offering Customers a variety of payment and financing methods when purchasing goods or services through various Merchants or Merchant Platforms.',
  },
  {
    type: 'text',
    content:
      '<strong>4.2.</strong> The Website and Mobile App display a list of independent Merchants who accept Tamara as  payment and financing option, as updated from time to time. These Merchants have entered into binding agreements to provide such products or services through the Merchant websites, apps or Merchant Platforms.',
  },
  {
    type: 'text',
    content:
      '<strong>4.3 Sharia Compliance:</strong> Tamara commits to comply with Sharia standards in all its transactions according to the resolutions of the Sharia committee of Tamara and does not impose any interest or late payment penalties.',
  },

  {
    type: 'subtitle',
    content: '5. Electronic Communication',
  },
  {
    type: 'text',
    content:
      '<strong>5.1.</strong> By creating a Tamara Account, you acknowledge and agree that you will communicate with us electronically. Therefore, you agree that Tamara may provide all communications, payment information, terms and conditions, information we are required to provide by law, all communications regarding any complaints and other information to you electronically to the email address you have provided to us. ',
  },
  {
    type: 'text',
    content:
      '<strong>5.2.</strong> To ensure that we are able to communicate with you electronically, you agree that it is your responsibility to notify us immediately of any change to your email address and mobile phone number or other information you provide to us. We may occasionally contact you to request an update of such information and any other information related to your Tamara Account.',
  },

  {
    type: 'subtitle',
    content: '6. Intellectual Property Rights',
  },
  {
    type: 'text',
    content:
      '<strong>6.1.</strong> You acknowledge that all Intellectual Property Rights on the Website and/or Mobile App (as applicable), shall automatically belong to Tamara, its licensors or third-party Merchants, to the fullest extent permitted by law. ',
  },
  {
    type: 'text',
    content:
      '<strong>6.2.</strong> The Tamara logo and associated symbols are trade marks of Tamara. Tamara’s trade marks may not be used in connection with any product or service that is not offered by Tamara, including any product or service that disparages Tamara or harms its reputation.',
  },
  {
    type: 'text',
    content:
      '<strong>6.3.</strong> You are prohibited from using any trade mark or any Intellectual Property Rights belonging to Tamara, from any part of the Tamara Services, and are prohibited from reproducing or modifying the Tamara Services or conducting any process of preparing, publishing, executing, sending, displaying, broadcasting or other means of exploiting the Tamara Services unless Tamara permits or expressly authorizes it in writing. In addition, you may not, and you agree not to or enable others to, copy, decompile, reverse engineer, disassemble, attempt to derive the source code of, decrypt, modify, or create derivative works of the Tamara Services or any part thereof (except as and only to the extent any foregoing restriction is prohibited by Applicable Laws).',
  },

  {
    type: 'subtitle',
    content: '7. Using the Website and Mobile App',
  },
  {
    type: 'text',
    content:
      '<strong>7.1.</strong> You are prohibited from using the Website and/or Mobile App to post any of the following content: any use of vulgar language, obscenity, insults, cultural or religious abuse, any political or critical content, or material that may threaten the public interest or national security, cause defamation, slander, libel, or any other content that may be offensive, obscene or indecent. ',
  },
  {
    type: 'text',
    content:
      '<strong>7.2.</strong> We reserve the right to terminate your relationship with us and your access to the Tamara Services to the extent that you publicly post (including, without limitation, on social media) any content relating to Tamara that is offensive, obscene, indecent or defamatory.',
  },

  {
    type: 'subtitle',
    content: '8. Product lists and availability',
  },
  {
    type: 'text',
    content:
      '<strong>8.1.</strong> You understand that Tamara is merely a financing company and does not bear any responsibility for the manufacturing, shipping, production or delivery of any of the products or services purchased via Tamara. Accordingly, Tamara shall not be liable for the availability, quality or any other characteristic of any products that are displayed on the Merchant’s website, app or the Merchant Platform.',
  },

  {
    type: 'subtitle',
    content: '9. After-sales service for products',
  },
  {
    type: 'text',
    content:
      '<strong>9.1.</strong> Tamara shall not be liable or responsible for any products or services sold through any Merchant websites, apps or Merchant Platforms. Such products and services will be provided and supported by Merchants, their manufacturers or their local agents only, as well as their suppliers, in accordance with the terms and conditions associated with each product or service. Tamara expressly excludes any warranty of any kind for the products or services sold on the Merchant websites, apps and Merchant Platforms. Any requests for technical support, customer service or after-sales service regarding products or services shall be directed to the Merchant concerned.',
  },

  {
    type: 'subtitle',
    content: '10. Payments',
  },
  {
    type: 'text',
    content:
      '<strong>10.1.</strong> Once you have created a Tamara Account in accordance with these Terms and Conditions, you will be able to access the Tamara Services when you choose to pay for goods or services using the Tamara Services payment and financing option with the relevant Merchant or Merchant Platform. ',
  },
  {
    type: 'text',
    content:
      '<strong>10.2.</strong> Tamara Services allow you to purchase goods or services from a Merchant or Merchant Platform. When you choose one of Tamara’s payment and financing options, different terms and conditions may apply in addition to these Terms and Conditions and varying fees may be charged by Tamara from time to time as permitted by Applicable Law, which are subsequently payable by you. Unless otherwise specified in the applicable terms and conditions, these Terms and Conditions shall be deemed incorporated into those additional terms and conditions. ',
  },
  {
    type: 'text',
    content:
      '<strong>10.3.</strong> Whenever possible, we will do our best to direct you to any separate terms and conditions available on the Website, but it is always your responsibility to check. We will also always aim to communicate any fees associated with any of the Tamara Services when selected, however again, it is always your responsibility to check the applicable fees on the Website. ',
  },
  {
    type: 'text',
    content:
      '<strong>10.4.</strong> You are responsible for understanding and accepting all fees associated with your Purchase Order as specified during the payment and financing process. Where any due amount is applicable, you undertake to pay it to Tamara in accordance with these Terms and Conditions. ',
  },
  {
    type: 'text',
    content:
      '<strong>10.5.</strong> Once you have chosen Tamara Services at the Merchant’s point of sale during the payment process, you will be asked to choose payment and financing method that will become effective and binding between you and Tamara in relation to the Purchase Order. ',
  },
  {
    type: 'text',
    content:
      '<strong>10.6.</strong> Including where such information is not already available via the Website and/or Mobile App, you shall be entitled to request a copy of the entire agreement you have with us at any time, which we shall aim to provide to you within five (5) business days of the request, or a time period otherwise permitted by Applicable Laws, whichever is later. You shall also be entitled to request any applicable transaction statements (including all fees, costs and all additional charges, in case of default) on a quarterly basis. ',
  },
  {
    type: 'text',
    content:
      '<strong>10.7.</strong> You acknowledge that you are fully responsible for any Purchase Order or Transaction regardless of whether the goods or services concerned are successfully delivered or provided to you (as applicable). ',
  },
  {
    type: 'text',
    content:
      '<strong>10.8.</strong> You acknowledge and agree that to complete a Transaction using Tamara you are required to have at least one appropriate repayment method, such as a credit or debit card, added to your Tamara Account and kept on file at all times (known as a <strong>“Card on File”</strong>). This means that if your existing Card on File has expired, been replaced or you no longer wish to use it as a repayment method, you will not be able to remove it from your Tamara Account unless and until you have added a replacement Card on File. You acknowledge that failure to provide a working Card on File will affect your ability to complete a successful Transaction. ',
  },
  {
    type: 'text',
    content:
      '<strong>10.9.</strong> Tamara reserves the right to make any change or modification to any payment and financing method or the provision of the Tamara Services. You understand that this means that we may in certain circumstances, for instance where we are unable to provide you with credit in relation to a Transaction (for any reason), deduct the entirety of a Transaction value from your Card on File. ',
  },
  {
    type: 'text',
    content:
      '<strong>10.10.</strong> Tamara provides electronic payment services through third-party service providers. Tamara shall not bear any liability for any error, damage or any loss that you may be exposed to as a result of using an electronic payment method. This is the responsibility of the third-party service provider.',
  },
  {
    type: 'text',
    content:
      '<strong>10.11.</strong> You must ensure that you have sufficient funds in your Tamara Account (via your Card on File), prior to submitting a Purchase Order or attempting to complete a Transaction. You are solely responsible for complying with any applicable transaction limits.',
  },
  {
    type: 'text',
    content:
      '<strong>10.12.</strong> Under these Terms and Conditions, you agree and authorise Tamara to withdraw the relevant amount necessary to complete a Transaction from the payment method stored in your Tamara Account on the date due for payment. In the event that a Transaction is rejected due to lack of funds covering the installment, an attempt to deduct such funds will be automatically made every two (2) days until the full amount is paid. Tamara reserves the right to refer your case to any applicable collection agency and/or share your details with any applicable regulators at its full discretion.',
  },
  {
    type: 'text',
    content:
      '<strong>10.13.</strong> You hereby warrant and represent that you have sufficient funds available to satisfy any financial obligations towards Tamara as applicable from time to time. Tamara shall have the right to cooperate with applicable Merchants in the event you fail to fulfil your obligations to pay any sums which are due and outstanding.',
  },
  {
    type: 'text',
    content:
      '<strong>10.14.</strong> You hereby agree that you understand and are aware of the potential consequences when you use the Tamara Services in violation of these Terms and Conditions.',
  },
  {
    type: 'text',
    content:
      '<strong>10.15.</strong> You agree that Tamara has the right, at its absolute discretion, to notify any relevant authorities or regulators, in the event of your delay, inability to pay or any type of suspicious activity.',
  },
  {
    type: 'text',
    content:
      '<strong>10.16.</strong> You hereby acknowledge and agree that Tamara may, from time to time, for Customer due diligence purposes pass your details on to applicable credit bureau agencies to run a credit report on your credit history and creditworthiness. If a credit report is returned as negative, you acknowledge that Tamara may restrict your access to Tamara Services.',
  },
  {
    type: 'text',
    content:
      '<strong>10.17.</strong> You hereby agree that you are the true beneficiary of the Tamara Services and that you do not use the Tamara Services for any money laundering or other illegal activities.',
  },
  {
    type: 'text',
    content:
      '<strong>10.18.</strong> You understand that if we become aware of any suspected or actual cases of fraud or fraudulent activity in relation with your use of Tamara Services or your Tamara Account generally, that we have the right to credit or debit your Tamara Account or otherwise charge you, as applicable (including: (a) withholding or otherwise delaying any Refund amount; or (b) retaining any fees paid by you (via your Tamara Account or otherwise); or (c) requiring you to immediately pay the remaining total amount of all outstanding instalments (to the extent applicable)) with regard to any relevant Transaction, until we determine, in our sole discretion, that the applicable Transaction did not involve any fraudulent activity. ',
  },

  {
    type: 'subtitle',
    content: '11. Refund of Payments',
  },
  {
    type: 'text',
    content:
      '<strong>11.1.</strong> Other than in relation to Tamara’s Buyer Protection Program, Tamara shall not be liable for any Merchant or Merchant Platform’s decision regarding Refunds, as applicable between you and the Merchant or the Merchant Platform. Tamara may elect, however, to play a role in facilitating such Refunds at its sole discretion, provided that such role does not imply any liability in connection with any Refund.',
  },

  {
    type: 'subtitle',
    content: '12. Specific Additional Terms',
  },
  {
    type: 'text',
    content:
      '<strong>12.1.</strong> There may be other terms and conditions which apply between you as a Customer and Tamara. These will apply depending on how you use our Mobile App, Website and certain Tamara Services. Such terms can be accessed on the Website, and relate to:',
  },
  {
    type: 'text',
    content: '<strong>12.2.</strong> Farah Program; and',
  },
  {
    type: 'text',
    content: '<strong>12.3.</strong> Tamara’s Buyer Protection Program.',
  },
  {
    type: 'text',
    content: 'Each, always, to the extent applicable.',
  },
  {
    type: 'subtitle',
    content: 'Section Three – General Terms',
  },

  {
    type: 'subtitle',
    content: '13. Confidentiality and Privacy',
  },
  {
    type: 'text',
    content:
      '<strong>13.1.</strong> Tamara is committed to maintaining the confidentiality of credit information and data in its possession. ',
  },
  {
    type: 'text',
    content:
      '<strong>13.2.</strong> In addition to the obligations at clause 5 above, you hereby agree to provide any information, including Identification Information or documentation reasonably required by Tamara to verify your identity in connection with your Tamara Account or any use of Tamara Services, and you authorise us to make any inquiries we believe are necessary in order to verify your identity. Tamara reserves the right to close your Tamara Account or suspend or limit your access to Tamara Services if we are unable to obtain or verify any such information to our satisfaction. ',
  },
  {
    type: 'text',
    content:
      '<strong>13.3.</strong> You hereby consent and authorise Tamara to use any or all of your personally identifiable information and personal data collected through the Website, the Mobile App or any Merchants/Merchant Platform from time to time and may be used or disclosed to other people on a need-to-know basis and always with a valid legal basis. This may include sharing your identifying information and any other information with third parties for the purposes of credit verification, anti-money laundering or other similar checks or for any other purpose that Tamara considers necessary in order to enable Tamara to provide the Tamara Services to you and to comply with all Applicable Laws. ',
  },
  {
    type: 'text',
    content:
      '<strong>13.4.</strong> You hereby agree to these Terms and Conditions and when accessing or using the Website or Mobile App, you hereby agree to our Privacy Policy, knowing that your personal information is collected and understanding how it will be handled. ',
  },
  {
    type: 'text',
    content:
      '<strong>13.5.</strong> If you do not agree with our policies and practices, you will not be able to use the Website or Mobile App and please do not continue to use Tamara Services. ',
  },
  {
    type: 'text',
    content:
      '<strong>13.6.</strong> You have the right to withdraw your consent to the processing of your personal data at any time, subject to contractual and statutory restrictions and written notice. ',
  },
  {
    type: 'text',
    content:
      '<strong>13.7.</strong> You shall not disclose to third parties any information received under these Terms and Conditions or any other contract concluded with Tamara. Any information related to Tamara’s business should be accessed in a confidential manner, and you shall be responsible for compensating Tamara for any loss of business or reputation, if this occurs as a result of any act that results from your access of such information.',
  },

  {
    type: 'subtitle',
    content: '14. Limitation of Liability',
  },
  {
    type: 'text',
    content:
      "<strong>14.1.</strong> Tamara is an independent service provider and is not a party to any direct arrangements between Customers and Merchants or other related third parties. Tamara shall not (outside of its obligations under Tamara's Buyer Protection Program) in any way be liable for any claim or dispute attributable to Merchants and shall not be liable for any failure related to or damages caused by the Merchants’ products or services’ mark, reliability, adequacy, originality, availability or legality.",
  },
  {
    type: 'text',
    content:
      '<strong>14.2.</strong> Third-party Merchants are independent service providers who are not subject to these Terms and Conditions and are only contracting with Tamara. Merchants shall not be considered employees, representatives or agents of Tamara. Merchants are fully responsible for all dealings that take place between them and Customers or other related dealings, and in the event of a dispute between you and any Merchant or third party, you undertake to release Tamara from any liability arising from or related to such disputes. Such undertaking is to release Tamara (and its agents and employees) from claims, demands, liabilities and indemnities of any kind or nature, known or unknown, disclosed or undisclosed, arising out of or in any way related to such disputes. ',
  },
  {
    type: 'text',
    content:
      '<strong>14.3.</strong>  By agreeing to these Terms and Conditions, you acknowledge the possibility of risks or errors arising from Merchants or any third-party service providers. Therefore, the use of the Tamara Services shall be your exclusive responsibility and Tamara does not bear any liability towards it. ',
  },
  {
    type: 'text',
    content:
      '<strong>14.4.</strong> Tamara shall not be liable to you or to any other person for any direct, indirect, incidental, special, penal, punitive or consequential damages that may arise, even if Tamara has been informed of the possibility of such damages, and Tamara shall not be liable for any damages, obligations or losses that you incur, arising from your use of or reliance on the Tamara Services or as a result of your inability to access or use the Tamara Services or from any Transaction or relationship that arose between you and a Merchant, even where Tamara was aware of the possibility of such damages occurring. Tamara shall not be responsible for any delay or failure in implementation, nor will it be held responsible in the event that a Merchant does not have the appropriate licenses and authorisations in place. ',
  },
  {
    type: 'text',
    content:
      '<strong>14.5.</strong> The Tamara Services are provided on an ‘as is’ basis, and Tamara disclaims all representations and warranties, express, implied, or statutory that are not expressly stated in these Terms and Conditions, including the implied warranties regarding the seller’s ability and suitability of its goods or services for a particular purpose to the fullest extent permitted by law. Tamara does not make any representation or warranty about the reliability, quality, sustainability, availability or original owner of the goods or services or any services ordered through the use of Tamara’s Services, nor does Tamara guarantee that the Tamara Services will be uninterrupted or error-free. To the fullest extent permitted by the Applicable Laws, you hereby acknowledge and agree that you assume all liability arising from your use of any of the Tamara Services. ',
  },
  {
    type: 'text',
    content:
      '<strong>14.6.</strong> The information on the Website and Mobile App is provided for general purposes only. Tamara shall make reasonable efforts to keep information up-to-date and correct, but does not provide any representations or warranties of any kind, whether express or implied, in terms of the completeness, accuracy, reliability, suitability or availability of the Website or Mobile App, information, services or related advertisements or graphics contained on the Website or Mobile App for any purpose, and therefore you shall rely on such information at your own risk. ',
  },
  {
    type: 'text',
    content:
      '<strong>14.7.</strong> For security and performance reasons, all Tamara Accounts are regularly monitored. ',
  },
  {
    type: 'text',
    content:
      '<strong>14.8.</strong> Tamara shall not be liable for any delay, interruption or failure in the provision of Tamara Services caused by a Force Majeure event. ',
  },
  {
    type: 'text',
    content:
      '<strong>14.9.</strong> If you do not agree to any of these Terms and Conditions, you must not access the Website or Mobile App, nor use Tamara Services.',
  },

  {
    type: 'subtitle',
    content: '15. Pledge',
  },
  {
    type: 'text',
    content:
      '<strong>15.1.</strong> This provision constitutes notice to you that we may pledge all of our rights, title and interest in and under these Terms and Conditions, including our right to any amount payable by you pursuant to these Terms and Conditions, to a third party beneficiary who will be entitled to the rights and benefits under these Terms and Conditions and may enforce the provisions hereof as if it were a party hereto. We will remain entitled to exercise all our rights, powers, discretions and remedies under these Terms and Conditions, and you should continue to pay any amount payable by you pursuant to, and give notices under, these Terms and Conditions to us, unless and until you receive written notice to the contrary.',
  },

  {
    type: 'subtitle',
    content: '16. Compensation',
  },
  {
    type: 'text',
    content:
      '<strong>16.1.</strong> You acknowledge and agree to indemnify and ward off damage from Tamara, its affiliates entities, sponsors, partners, directorate, liability, employees and reimbursement of all losses to them as well as the value of damages, liabilities, claims, judgments, settlements, fines, costs and expenses (including any expenses, legal fees, investigation costs, and attorneys’ fees), in the case Tamara suffers any damages caused by you or if it arises or is related to your breach of these Terms and Conditions, the Privacy Policy or your (or any third party authorised by you) use of the Tamara Services.',
  },

  {
    type: 'subtitle',
    content: '17. Notifications',
  },
  {
    type: 'text',
    content:
      '<strong>17.1.</strong> All notifications and other communications under these Terms and Conditions shall be in writing by correspondence to the Tamara e-mail shown on the Website.',
  },

  {
    type: 'subtitle',
    content: '18. General',
  },
  {
    type: 'text',
    content:
      '<strong>18.1.</strong> The rights and obligations of the parties stipulated in these Terms and Conditions shall be governed by and interpreted in accordance with the provisions of the laws of the United Arab Emirates. ',
  },
  {
    type: 'text',
    content:
      '<strong>18.2.</strong> By agreeing to these Terms and Conditions, you undertake to submit unconditionally to the exclusive jurisdiction of the courts of the United Arab Emirates for any legal proceedings arising out of or in connect with these Terms and Conditions, the legal relationships established by them, or the various subject matters hereof. The parties hereto hereby waive and agree not to assert (by way of motion, as a defence, or otherwise) that any such proceeding is brought in an inconvenient forum or that the venue thereof is improper. ',
  },
  {
    type: 'text',
    content:
      '<strong>18.3.</strong> You hereby agree to cooperate with Tamara to the fullest extent permitted by Applicable Laws, including agreeing to answer in writing any questions or providing information to assist Tamara in conducting any internal investigation or inquiry. ',
  },
  {
    type: 'text',
    content:
      '<strong>18.4.</strong> Under these Terms and Conditions, you acknowledge that Tamara may disclose information about you and your aforementioned account or any other account with any regulators under the Applicable Laws, any applicable bank card association rules in force from time to time, and/or the authorised representative of applicable regulators, including, but not limited to, any credit bureau agency through the concluded membership agreement and the approved business rules for the exchange of information and/or to any other party as approved by the competent regulatory authority or any other local applicable financial institution. ',
  },
  {
    type: 'text',
    content:
      '<strong>18.5.</strong> If you pay us late, we may provide details of your late payment or failure to pay us to credit bureau agencies, as engaged by Tamara from time to time, who may update your credit record accordingly. This may affect your credit rating and make it more difficult, or expensive, for you to obtain credit in the future. ',
  },
  {
    type: 'text',
    content:
      '<strong>18.6.</strong> If any term or provision of these Terms and Conditions is determined to be ineffective, unenforceable or invalid, then only that term or provision shall be deemed invalid without affecting in any way the rest of these Terms and Conditions. ',
  },
  {
    type: 'text',
    content:
      '<strong>18.7.</strong> These Terms and Conditions shall become effective on the date on which you access the Website or Mobile App and/or indicate your acceptance by creating a Tamara Account and shall remain in effect until cancelled or revoked by Tamara at its full discretion. ',
  },
  {
    type: 'text',
    content:
      '<strong>18.8.</strong> If Tamara elects, at its sole discretion, to deactivate your access to the Tamara Account, subsequently terminating these Terms and Conditions, it will notify you by sending a notification to the email address you have provided to Tamara. You hereby agree and acknowledge that Tamara has the absolute right to terminate these Terms and Conditions with or without reason and has no obligation to notify you of the reason for the termination of these Terms and Conditions. ',
  },
  {
    type: 'text',
    content:
      '<strong>18.9.</strong> By closing your Tamara Account by following the instructions on the Website or Mobile App, these Terms and Conditions will cease to apply. For the avoidance of doubt, you will remain liable for all obligations relating to your Tamara Account and all outstanding amounts that you owe Tamara even after your Tamara Account is closed and/or these Terms and Conditions cease to apply.',
  },

  {
    type: 'subtitle',
    content: '19. Entire Agreement',
  },
  {
    type: 'text',
    content:
      '<strong>19.1.</strong> These Terms and Conditions, together with the Privacy Policy and any other terms agreed between you and Tamara from time to time represent the entire agreement between you and Tamara.',
  },

  {
    type: 'subtitle',
    content: '20. Complaints',
  },
  {
    type: 'text',
    content:
      '<strong>20.1.</strong> We are committed to providing an excellent standard of service to our customers. We value feedback from customers greatly because it helps us to continually improve our service. If you do not feel that you are receiving excellent customer service, or that something could be improved, please do tell us about it. ',
  },
  {
    type: 'text',
    content:
      '<strong>20.2.</strong> If we have fallen short of the excellent standards we have set for ourselves then we would like the opportunity to put things right. However, we recognise that things can go wrong occasionally and if this occurs, we are committed to resolving matters promptly and fairly. Should you wish to make a complaint you may do so by communicating with us via Tamara’s Customer Help Center. ',
  },
  {
    type: 'text',
    content:
      '<strong>20.3.</strong> Upon receiving your complaint, we will: (i) send a written acknowledgement of your complaint within ten (10) business days or a time period otherwise permitted by Applicable Laws (whichever is later) of receiving it and inform you of any missing details; (ii) investigate the concerns and arrange a discussion with you to try to agree how to resolve the issues; (iii) respond with our final decision on the matter, setting out the conclusion of our investigation and any proposals to rectify or resolve the matter, within ten (10) business days of receiving your complete complaint or a time period otherwise permitted by Applicable Laws (whichever is later); and (iv) remind you that you may be entitled to refer your complaint to the competent regulatory authority and provide details for doing so, at the end of our complaints process.',
  },

  {
    type: 'subtitle',
    content: '21. Errors',
  },
  {
    type: 'text',
    content:
      '<strong>21.1.</strong> Where we become aware of any error or malfunction to your Tamara Account, we will: (i) promptly return any collected amounts arising as a result of such error, as applicable; (ii) process and correct such errors for any affected customers within sixty (60) business days, or a time period otherwise permitted by Applicable Time, whichever is later, starting from the date of determining the error; and (iii) inform you of such error and that corrective measures have been taken.',
  },

  {
    type: 'subtitle',
    content: 'Section Four - Definitions',
  },
  {
    type: 'text',
    content:
      '22. The following references, words, expressions and terms have the meanings set forth in front of each of them in these Terms and Conditions:',
  },
  {
    type: 'text',
    content:
      '<strong>Applicable Laws</strong>: means any applicable laws and regulations to which Tamara and/or the Customer are subject to, including, but not limited to, any applicable bank card association rules in force from time to time. ',
  },
  {
    type: 'text',
    content:
      '<strong>Customer</strong>: means the customer of the Merchant or Merchant Platform who creates a Tamara Account. ',
  },
  {
    type: 'text',
    content:
      '<strong>Dispute</strong>: means any request for refund, deduction, compensation, counterclaim or dispute of any kind brought by the Customer against the Merchant in respect of the goods or services that resulted in an approved Transaction. ',
  },
  {
    type: 'text',
    content:
      '<strong>Farah Program</strong>: an exclusive rewards service provided by Tamara which allows you to collect and redeem certain available rewards, discounts or other offers (referred to by Tamara as “<strong>Farah</strong>”) through our Mobile App. You can find the Farah Program Terms and Conditions on the Website. ',
  },
  {
    type: 'text',
    content:
      "<strong>Force Majeure</strong>: means any circumstance beyond a party’s reasonable control that affects that party's performance of its obligations under these Terms and Conditions, including but not limited to fire, flood, accidents, war, strikes, economic embargo, military operations, or regulatory requirements. ",
  },
  {
    type: 'text',
    content:
      '<strong>Identification Information</strong>: means the information required to be provided by the Customer to Tamara in order to create an account for them with Tamara, as collected by Tamara or the Merchant or Merchant Platform (as applicable) for the purposes of providing Tamara Services to Customers. ',
  },
  {
    type: 'text',
    content:
      '<strong>Intellectual Property Rights</strong>: means any patents, utility models, rights to inventions, copyright and related rights, trade marks and service marks, trade names and domain names, rights in get-up, goodwill and the right to sue for passing off or unfair competition, rights in designs, rights in computer software, database rights, rights to preserve the confidentiality of information (including know-how and trade secrets) and any other intellectual property rights, including all applications for (and rights to apply for and be granted), renewals or extensions of, and rights to claim priority from, such rights and all similar or equivalent rights or forms of protection which subsist or will subsist, now or in the future, in any part of the world. ',
  },
  {
    type: 'text',
    content:
      '<strong>Merchant Platform</strong>: means, including but not limited to websites and applications, which allow multiple Merchants to offer goods and services to customers through a single platform. ',
  },
  {
    type: 'text',
    content:
      '<strong>Merchant</strong>: means any person that permits its customers to utilise the Tamara Services pursuant to an independent agreement, as updated from time to time. ',
  },
  {
    type: 'text',
    content:
      '<strong>Mobile App</strong>: means the Tamara mobile application as available to download from the relevant digital stores. ',
  },
  {
    type: 'text',
    content:
      '<strong>Net Amount</strong>: means the total amount paid by the Customer including, where applicable, any value-added tax and shipping charges in connection with a Purchase Order that gives rise to an approved Transaction minus: (i) any Refunds; and (ii) any deductions, credits or reductions claimed by the Customer and approved by the relevant Merchant. ',
  },
  {
    type: 'text',
    content:
      '<strong>Purchase Order</strong>: means a request submitted by the Customer through a Merchant Platform, the Website, Mobile App, the Merchant’s website, or any other applications or points of sale to use the Tamara Services to purchase goods or services from the relevant Merchant or Merchant Platform. ',
  },
  {
    type: 'text',
    content:
      '<strong>Refunds</strong>: means an amount (that may be in dispute) paid by the Customer to a Merchant using the Tamara Services in connection with an approved Transaction which is subsequently returned to the Customer following the resolution of such Dispute. ',
  },
  {
    type: 'text',
    content:
      '<strong>Tamara Account</strong>: means the account created by the Customer to use the Tamara Services, whose use and operation will be subject to these Terms and Conditions. ',
  },
  {
    type: 'text',
    content:
      '<strong>Tamara Services</strong>: means the payment and financing services provided by Tamara, as updated from time to time, that the Customer selects on the Merchant’s website, the Merchant Platform or at any other point of sale with the Merchant under which the Customer chooses to purchase goods or services from the Merchant or Merchant Platform using the Tamara Services subject to these Terms and Conditions. ',
  },
  {
    type: 'text',
    content:
      '<strong>Tamara’s Buyer Protection Program</strong>: means the scheme, as amended from time to time, that following a successful claim by you as a Customer, entitles you to full coverage for the Net Amount (being the full purchase price of the applicable goods or services provided by the applicable Merchant or Merchant Platform, plus any original shipping costs paid if applicable, which have been purchased by you utilising the Tamara Services). The Buyer Protection Program Terms and Conditions, and further information can be found in our FAQ’s section, on the Website. ',
  },
  {
    type: 'text',
    content:
      '<strong>Terms and Conditions</strong>: means these Customer Terms and Conditions as amended from time to time. ',
  },
  {
    type: 'text',
    content:
      '<strong>Transaction</strong>: means a request submitted via your Tamara Account, pursuant to a Purchase Order, to make use of the Tamara Services in order to complete and settle such Purchase Order with the relevant Merchant or Merchant Platform. ',
  },
  {
    type: 'text',
    content:
      '<strong>Transaction Information</strong>: means all information related to the Purchase Order and the Transaction. ',
  },
  {
    type: 'text',
    content:
      '<strong>We</strong>: References to “we” or “we” as a possessive, object, or other similar pronouns in these Terms and Conditions are references to Tamara and its affiliated entities and persons. ',
  },
  {
    type: 'text',
    content:
      "<strong>Website</strong>: means Tamara's website at <a href='https://tamara.co' target='_blank'>https://tamara.co</a>.",
  },
  {
    type: 'text',
    content:
      '<strong>You</strong>: References to “you”, or the possessive pronoun “your” or other similar pronouns in these Terms and Conditions are references to the relevant Customer referred to in the Identification Information to be provided prior to using the Tamara Services.',
  },
]
